import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";

interface StateInterface {
  isFetching: boolean;
  fields: string[];
  translatedMessage: string;
};

const initialState: StateInterface = {
  isFetching: false,
  fields: [],
  translatedMessage: ""
};

export const taskTemplateCreateReducer = (state: StateInterface = initialState, action: ActionInterface): StateInterface => {
  switch (action.type) {
    case Constants.GLOBAL_TASK_TEMPLATE_CREATE_REQUEST:
      return {
        ...state,
        isFetching: true
      };

    case Constants.GLOBAL_TASK_TEMPLATE_CREATE_SUCCESS:
      return {
        ...state,
        isFetching: false
      };

    case Constants.GLOBAL_TASK_TEMPLATE_CREATE_FAILURE:
      return {
        ...state,
        isFetching: false,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.GLOBAL_TASK_TEMPLATE_CREATE_CLEAR:
      return {
        ...initialState
      };

    case Constants.AUTH_SIGNOUT:
      return {
        ...initialState
      };

    default:
      return state;
  }
};
